import { PerformanceDashboard } from '@futrli-sdk/performance_dashboards';

import {
  addToPerformanceDashboards,
  removeFromPerformanceDashboards
} from '../../predict/src/core/api/reporting/performance-dashboards';

import { createMutation } from '../utils/mutations';
import { performanceDashboardsQueryKey } from '../queries/performanceDashboards';
import { queryClient } from '../core/queryClient';

// ── Add to Performance Dashboards ──

export interface AddToPerformanceDashboardsInput {
  reportId: string;
  reportName: string;
  order?: number | null;
}

export const addToPerformanceDashboardsMutation = (workspaceId: string, organisationId: string) =>
  createMutation<AddToPerformanceDashboardsInput, PerformanceDashboard>({
    mutationFn: async (input: AddToPerformanceDashboardsInput) =>
      addToPerformanceDashboards(workspaceId, organisationId, input.reportId, input.reportName, input.order),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: performanceDashboardsQueryKey(organisationId, workspaceId)
      });
    }
  });

// ── Remove from Performance Dashboards ──

export interface RemoveFromPerformanceDashboardsInput {
  dashboardId: string;
}

export const removeFromPerformanceDashboardsMutation = (workspaceId: string, organisationId: string) =>
  createMutation<RemoveFromPerformanceDashboardsInput, void>({
    mutationFn: async (input: RemoveFromPerformanceDashboardsInput) =>
      removeFromPerformanceDashboards(workspaceId, organisationId, input.dashboardId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: performanceDashboardsQueryKey(organisationId, workspaceId)
      });
    }
  });
